import { render, staticRenderFns } from "./QuestionFeedback.vue?vue&type=template&id=3aeaf4cf&"
import script from "./QuestionFeedback.vue?vue&type=script&lang=js&"
export * from "./QuestionFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports